import { URI } from '@/config/config';

export default async ({ rootState }, { cpf }) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };
  const path = new URL(`${URI}control-panel/consumer/cpf/${cpf}`);

  const response = await fetch(path, opts);
  const jsonResult = await response.json();
  if (jsonResult.status >= 400) {
    return Promise.reject(jsonResult);
  }

  return jsonResult;
};
